// @ts-nocheck
import configureStore  from './configureStore';

const store = configureStore();

export { store };
export { default as configureStore } from './configureStore';
